import { GrammaticalGender } from 'enum'

export function determineGrammaticalGender(word: string): GrammaticalGender {
  const wordFormatted = word.toLowerCase()
  const firstWord = wordFormatted.split(' ')[0].toLowerCase()

  const lastLetter = firstWord.slice(-1)

  const lastThreeLetters = firstWord.slice(-3)
  if (lastThreeLetters === 'dad') return GrammaticalGender.F
  return lastLetter === 'a' ? GrammaticalGender.F : GrammaticalGender.M
}
